var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatellite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5729 10.9252L16.2437 10.2544L17.825 11.8356L23 6.66061L19.0708 2.73145L13.8958 7.90645L15.477 9.48769L14.8062 10.1585L11.8833 7.1877C11.5 6.80436 10.925 6.80436 10.5416 7.1877L9.39162 8.3377L8.33745 7.28353C8.4812 6.80436 8.33745 6.22936 7.95412 5.84603C7.37912 5.27103 6.42078 5.27103 5.84578 5.84603C5.27078 6.42103 5.27078 7.37936 5.84578 7.95436C6.22912 8.3377 6.7562 8.48145 7.28328 8.3377L8.33745 9.39186L7.18745 10.4939C6.80412 10.8773 6.80412 11.4523 7.18745 11.8356L10.1583 14.8064L9.48745 15.4773L7.9062 13.896L2.7312 19.071L6.66037 23.0002L11.8354 17.8252L10.2541 16.2439L10.925 15.5731L13.8958 18.5439C14.2791 18.9273 14.8541 18.9273 15.2375 18.5439L18.5437 15.2377C18.927 14.8544 18.927 14.2794 18.5437 13.896L15.5729 10.9252Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.89995 3.4502C4.98328 3.4502 3.44995 4.98353 3.44995 6.9002C3.44995 7.13978 3.64162 7.37936 3.92912 7.37936C4.1687 7.37936 4.40828 7.1877 4.40828 6.9002C4.40828 5.51061 5.51037 4.40853 6.89995 4.40853C7.13953 4.40853 7.37912 4.21686 7.37912 3.92936C7.37912 3.64186 7.13953 3.4502 6.89995 3.4502Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.89998 2.58724C7.13957 2.58724 7.37915 2.39557 7.37915 2.10807C7.37915 1.86849 7.18748 1.62891 6.89998 1.62891C4.02498 1.62891 1.62915 3.97682 1.62915 6.89974C1.62915 7.13932 1.82082 7.37891 2.10832 7.37891C2.3479 7.37891 2.58748 7.18724 2.58748 6.89974C2.58748 4.50391 4.50415 2.58724 6.89998 2.58724Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.9 0.958333C7.13958 0.958333 7.37917 0.766667 7.37917 0.479167C7.37917 0.239583 7.1875 0 6.9 0C3.11458 0 0 3.11458 0 6.9C0 7.13958 0.191667 7.37917 0.479167 7.37917C0.71875 7.37917 0.958333 7.1875 0.958333 6.9C0.958333 3.59375 3.59375 0.958333 6.9 0.958333Z",
    fill: "#4F4F4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.bfce3c4fe5e7d965f3a9107d85de29dc.svg";
export { ForwardRef as ReactComponent };